/**
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {alertIcWarning24px} from '@ey/motif-react-wrapper/assets/icons/index';
import MotifRadioButton from '@ey/motif-react-wrapper/RadioButton';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import Icon from '../BaseComponentWrappers/MotifIcon';

function RadioButton(props) {
	const {
		radioName,
		radioId,
		isChecked,
		onChange,
		onClick,
		onKeyDown,
		disabled,
		labelValue,
		iconTitle,
		customIcon,
		statusLabel,
		messageLabel,
		radioTitle,
		radioValue,
		noOfLines = noOfLines !== undefined ? noOfLines : 1,
		radioButtonCount,
		isAresView,
		ellipse,
		isPrint = false,
		tooltipClass
	} = props;

	return (
		<StyledRadioWrapper
			key={radioId}
			className={`StyledRadioWrapper ${radioButtonCount > 4 ? 'sectionRadioContainer' : ''}
						${isChecked && messageLabel ? 'MessageLabelVisible' : ''}`}
		>
			<StyledMotifRadioButton
				name={radioName}
				id={radioId}
				checked={isChecked}
				onChange={onChange}
				disabled={disabled}
				onClick={onClick}
				onKeyDown={onKeyDown}
				title={radioTitle}
				value={radioValue}
			>
				{customIcon && (
					<span title={iconTitle}>
						<SVGICONS styleName="medium" name={customIcon} hoverText={iconTitle} />
					</span>
				)}
				{!isPrint && !isAresView ? (
					<EllipseControl content={labelValue} tooltip={labelValue} noOfLines={noOfLines} />
				) : (
					<>
						{!isPrint && ellipse ? (
							<EllipseControl
								tooltipClass={tooltipClass}
								content={labelValue}
								tooltip={labelValue}
								noOfLines={noOfLines}
							/>
						) : (
							<span htmlFor={radioId}>{labelValue}</span>
						)}
					</>
				)}
				{statusLabel && <span className="statusLabel">{statusLabel}</span>}
			</StyledMotifRadioButton>
			{isChecked && messageLabel ? (
				<section className="RadioMessageWrapper">
					<Icon src={alertIcWarning24px} className="alert-icon" size="16" />
					<span className="RadioMessageLabel">{messageLabel}</span>
				</section>
			) : (
				<React.Fragment />
			)}
		</StyledRadioWrapper>
	);
}

export default RadioButton;

const StyledRadioWrapper = styled.section`
	display: flex;
	flex-direction: column;
	.RadioMessageWrapper {
		width: calc(100% - var(--px-100));
		display: flex;
		align-items: center;
		padding: var(--px-10) 0 0 0;
		pointer-events: none !important;
		cursor: not-allowed !important;
		.motif-icon {
			display: inline-flex;
			svg {
				margin-right: var(--px-10);
				fill: var(--orange-500) !important;
				path {
					fill: var(--orange-500) !important;
				}
			}
		}
		.RadioMessageLabel {
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-24);
			pointer-events: none !important;
			cursor: not-allowed !important;
			color: var(--neutrals-900);
		}
	}
`;

const StyledMotifRadioButton = styled(MotifRadioButton)``;
